<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/190Rvo3/image/prevcover.jpg?1725038471826" alt="This image is the cover for the book Witch's Kiss, The Witch's Kiss Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Witch's Kiss, The Witch's Kiss Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this YA fantasy romance debut, a teenage girl is about to learn that the only thing more dangerous than being a witch is falling in love.</b></p><p> Sixteen-year-old Merry is fed up with her feuding family and nonexistent social life. High school is a terrible time to have magic shooting from her fingertips without warning. </p> Then Merry meets sweet, sensitive Jack, and can’t resist falling under his spell. There’s just one problem: he’s part of an evil, centuries-old curse that Merry is supposed to break. Is Merry about to lose her heart<i> and</i> her life? Or will true love’s kiss save the day?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katharine Corr, Elizabeth Corr
      </h2>
      
      <p class="authorDescription body article"><P> Katharine and Elizabeth Corr are sisters and writing partners. They are the authors of the Witch&rsquo;s Kiss Trilogy and the Solanum Duology. Their novels <I>A Throne of Swans</I> and <I>Queen of Gods</I> have appeared on YA bestseller lists. The Corr sisters grew up in Essex and now live ten minutes away from each other in Surrey with their families. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c39a55c